export const dayjsWeekdayIdentifiers = {
  0: 'M',
  1: 'TU',
  2: 'W',
  3: 'TH',
  4: 'F',
  5: 'SA',
  6: 'SU',
}
